/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


import moment from "moment";
import 'moment/locale/fr';

moment.locale(document.documentElement.lang || 'fr');

require('./bootstrap');

import Vue from 'vue'
import Scrollspy, {Easing} from 'vue2-scrollspy';
import VueScrollTo from 'vue-scrollto';

import ClipboardJS from 'clipboard'
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

import MaxLengthInput from './components/forms/MaxLengthInput.vue'
import Wysiwyg from './components/forms/Wysiwyg.vue'
import Dropdown from './components/layout/Dropdown.vue'
import DropdownClick from './components/layout/DropdownClick.vue'
import Modal from './components/layout/Modal.vue'
import MaxLengthTextarea from './components/forms/MaxLengthTextarea.vue'
import AppNotifications from './components/AppNotifications/AppNotifications.vue'
import inputPassword from './components/forms/inputPassword.vue'
import Tabs from './components/layout/Tabs.vue'
import Tab from './components/layout/Tab.vue'
import Accordion from './components/layout/Accordion.vue'
import OrderSummaryTable from './components/tables/OrderSummaryTable.vue'
import FileUploader from './components/forms/FileUploader.vue'
import FileUploaderCropper from "./components/forms/FileUploaderCropper";
import BadgeForm from './components/forms/BadgeForm.vue'
import ExtendedBadgeForm from './components/forms/ExtendedBadgeForm.vue'
import CompanyForm from './components/forms/CompanyForm.vue'
import StartupForm from './components/forms/StartupForm.vue'
import Snackbar from './components/AppNotifications/Snackbar.vue'
import ToggleFavoriteButton from './components/forms/ToggleFavoriteButton.vue'
import ToggleVerifiedButton from "./components/forms/ToggleVerifiedButton"
import ToggleValidatedButton from "./components/forms/ToggleValidatedButton"
import ToggleStatusButton from './components/forms/ToggleStatusButton'
import ToggleButton from './components/forms/ToggleButton.vue'
import searchSelect from './components/forms/searchSelect.vue'
import searchSelectTooltip from "./components/forms/searchSelectTooltip";
import SimpleSearchSelect from './components/forms/SimpleSearchSelect.vue'
import DeleteConfirmButton from './components/forms/DeleteConfirmButton.vue'
import BringOwnBadgesField from './components/forms/BringOwnBadgesField.vue'
import RefuseMealsField from './components/forms/RefuseMealsField.vue'
import ContactLunch from './components/forms/ContactLunch.vue'
import cvlibMultiSelect from './components/forms/cvlibMultiSelect.vue'
import CompanySubscriptionMultiSelect from './components/forms/CompanySubscriptionMultiSelect.vue'
import LogisticMultiCompanySelect from './components/forms/LogisticMultiCompanySelect.vue'
import AddUpdateDeleteForm from './components/forms/AddUpdateDeleteForm.vue'
import LunchDayMeals from './components/forms/LunchDayMeals.vue'
import StandConfigFurnitureForm from './components/forms/StandConfigFurnitureForm.vue'
import CvlibPackForm from './components/forms/CvlibPackForm.vue'
import DayTimeRangeForm from "./components/forms/DayTimeRangeForm"
import OverlappedDayTimeRangeForm from "./components/forms/OverlappedDayTimeRangeForm"
import AppointmentsManagement from "./components/forms/Appointments/AppointmentsManagement.vue";
import Vstyle from './components/Vstyle.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import scrollSnapPolyfill from 'css-scroll-snap-polyfill'
import VueBrowserUpdate from 'vue-browserupdate'
import Validations from './components/validations/validations'
import CompanyValidations from "./components/validations/company_validations";
import VueTippy, {TippyComponent} from "vue-tippy";
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor as MarkdownEditor } from '@toast-ui/vue-editor';
import GenerateAppointmentForm from "./components/forms/GenerateAppointmentForm.vue";
import DayTimeRangeSelector from "./components/forms/DayTimeRangeSelector.vue";
import CompanyComment from "./components/forms/CompanyComment.vue";
import CompanyTimeline from "./components/CompanyTimeline.vue";
import TodoListModal from "./components/todo-list/TodoListModal.vue";

import Sortable from 'sortablejs';

window.Vue = Vue;

Vue.use(VueBrowserUpdate, {
    options: {
        // Your browser update options
        container: document.body,
    },
});

Vue.use(Scrollspy, {
    easing: Easing.Exponential.Out
});

Vue.use(VueScrollTo, {
    offset: -100
});

Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);


var vm = new Vue({
    el: "#app",
    data: {
        enabled: true, // generic attribute
        disabled: false, // generic attribute
        counts: {}, // generic attribute
        section: 0,
        snackbars: [
            /* {id: 1, content: 'Notification neutre', type: "info", isOpen: false, autoDestroy: 5},
             {id: 2, content: 'Notification de succès', type: "success", isOpen: false, autoDestroy: 10},
             {id: 3, content: 'Notification d\'échec', type: "error", isOpen: false},*/
        ],
        waitingListConfirm: {
            total: 0,
            freed: 0,
            expected: 0,
            messages: { noIncrease: '', partial: '', all: '' },
        },
        WYSIWYGcustomToolbar: [
            ['bold', 'italic', 'underline'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['image', 'code-block']
        ],
        optionalDisplay:
            {'suscribeconfirmationmodal': false},
        withEcoTax: false,
        withNGOSupport: false,
        subConfirmation: false,
        communicationEmailConfirmed: false,
        billingEmailConfirmed: false,
        submitting: false,
        studentSubmitting: false,
        formSubmitting: false, // set by forms to show the submitting overlay and block a second submit
        config: {
            stand: {
                days: {},
                size_limits_limit: {},
                size_quantity_total: {},
                size_limits_initial_total: 0,
                formatted_days: {},
            },
            lunch: {
                days: {}
            },
            startup_stand: {
                day: null,
                size_limits_limit: {},
                size_quantity_total: {},
                size_limits_initial_total: 0
            },
            ong_stand: {
                day: null,
                size_limits_limit: {},
                size_quantity_total: {},
                size_limits_initial_total: 0
            },
            lodge: {
                days: {},
                studyLevels: {}
            },
            contactLunch: {
                days: {}
            },
            startup_presentation: {
                aperitifs: {},
                available_room_periods: {},
                edition_room_periods: {},
                studyLevels: {}
            },
            presentation: {
                aperitifs: {},
                available_room_periods: {},
                edition_room_periods: {},
                studyLevels: {}
            },
            workshop: {
                aperitifs: {},
                available_room_periods: {},
                edition_room_periods: {},
                studyLevels: {}
            },
        },
        subscription: {
            stand: {
                type: null,
                ui_type: null,
                name: null,
                days: {},
                availabilities: null,
                lunch_included: null,
                size: null,
                has_custom_wall: null,
                custom_wall_price: null,
                furnitures_included: {}
            },
            lunch: {
                days: {},
            },
            lodge: {
                name: null,
                description: null,
                type: null,
                study_levels: {},
                days: {}
            },
            startup_presentation: {
                duration: null,
                study_levels: {},
                day: null,
                room: null,
                slot: null,
                name: null,
                company_name: "",
                description: null,
                speaker: null,
                language: null
            },
            presentation: {
                duration: null,
                study_levels: {},
                day: null,
                room: null,
                slot: null,
                name: null,
                company_name: "",
                description: null,
                speaker: null,
                language: null
            },
            workshop: {
                duration: null,
                study_levels: {},
                day: null,
                room: null,
                slot: null,
                name: null,
                company_name: "",
                description: null,
                accept_invites: null,
                waiting_list_enabled: false,
                speaker: null,
                language: null
            },
            contact_lunch: {
                name: "",
                lunches: {},
                extra: {}
            }
        },
        student: {
            firstname: '',
            lastname: '',
            picture: '',
            email: '',
            communication_email: '',
            phone: '',
            birth_date: '',
            gender: '',
            study_level: '',
            study_section: '',
            study_minor_section: '',
            job_types: [],
            languages: [],
            linkedin: '',
            portfolio: '',
        },
        job_types_map: {},
        languageNames: [],
        levelNames: [],
        has_portfolio: [],
        favorites: {},
        verified: {},
        validated: {},
        openComments: {},
        commentCounts: {},
        showBannerComments: false,
        statuses: {},
        goodiesReceived: {},
        cvlib: {
            export: 0,
            selectedStudents: {},
            studentsToInvite: {},
            selectedActivity: {
                id: null
            },
            toAccept: null,
            toCancel: null,
            toMessage: null,
            toDelete: null,
            toMove: null,
            cancelFrom: null,
            showCancelWarning: false,
            toDecline: null,
            toAskForChange: null,
            toAskNewInvite: null,
            toBook: {
                id: null,
                name: null,
                status: null,
                date: null,
                time: null,
                preference: null,
            },
            invitation: null
        },
        search: {
            selectedItems: {}
        },
        admin: {
            selectCompany: null,
            toUnsubscribe: null,
            toDelete: null,
            toDeleteRoute: null,
            selectedRole: null,
            setSponsor: null,
            setPreviousSponsor: null,
            markdownContent: '',
            selectedLang: null,
            firstSelectedLang: null,
            selectedRecipients: [],
        },
        register: null,
        cancelRequest: null,
        acceptInvitation: null,
        declineInvitation: null,
        askForChange: null,
        askNewInvite: null,
        sendMessage: null,
        withPrefs: false,
        bill: {
            status: '',
            expire_at: null
        },
        billSendEmail: {
            emailMode: 'standard',
            customSubject: '',
            customGreeting: '',
            customContent: '',
            customSalutation: '',
            customSignature: '',
            defaultsLoaded: false,
            isSending: false,
        },
    },
    mounted: function () {
        scrollSnapPolyfill()
    },
    computed: {
        standElementSizes() {
            var result = [];

            for (let elem of this.$refs['stand_sizes'].elements) {
                if (elem.size !== null && elem.size !== '' && result.indexOf(parseInt(elem.size)) === -1) {
                    result.push(parseInt(elem.size));
                }
            }

            return result;
        },
        studentProfileJobs() {
            var result = [];
            for (let selectedJob of this.student.job_types) {
                result.push(this.job_types_map[selectedJob]);
            }

            return result.sort().join(", ");
        },
        studentProfileLanguages() {
            var result = [];

            for (let language of this.student.languages) {
                result.push({
                    "language": this.languageNames[language.languages],
                    "level": this.levelNames[language.level],
                });
            }

            return result;
        },
        hasPortfolio() {
            return this.student.study_section ? (this.has_portfolio[this.student.study_section].has_portfolio == true) : false
        },
        portfolioTitle() {
            return this.student.study_section ? this.has_portfolio[this.student.study_section].title : ''
        },
        selectedPresentationRoomPeriods() {
            var result = {};
            for (let room_period in this.config.presentation.available_room_periods) {
                if (this.config.presentation.edition_room_periods[room_period])
                    result[room_period] = this.config.presentation.available_room_periods[room_period];
            }
            return result;
        },
        selectedWorkshopRoomPeriods() {
            var result = {};
            for (let room_period in this.config.workshop.available_room_periods) {
                if (this.config.workshop.edition_room_periods[room_period])
                    result[room_period] = this.config.workshop.available_room_periods[room_period];
            }
            return result;
        },
        isStandComplete() {
            const baseComplete = this.subscription.stand.name
                && this.subscription.stand.type
                && (Object.keys(this.subscription.stand.days).length > 0)
                && (Object.values(this.subscription.stand.days).indexOf(true) > -1)
                && this.subscription.stand.size;

            if (!baseComplete) {
                return false;
            }

            // Custom wall choice is required for equipped stands
            if (this.subscription.stand.type === 'equipped' && this.subscription.stand.size) {
                return this.subscription.stand.has_custom_wall !== null
                    && this.subscription.stand.has_custom_wall !== undefined;
            }

            return true;
        },
        isPresentationComplete() {
            return this.subscription.presentation.name
                && this.subscription.presentation.duration
                && this.subscription.presentation.description
                && this.subscription.presentation.speaker
                && this.subscription.presentation.language
                && this.subscription.presentation.day
                && this.subscription.presentation.room
                && this.subscription.presentation.slot
        },
        isWorkshopComplete() {
            return this.subscription.workshop.name
                && this.subscription.workshop.duration
                && this.subscription.workshop.description
                && this.subscription.workshop.speaker
                && this.subscription.workshop.language
                && this.subscription.workshop.day
                && this.subscription.workshop.room
                && this.subscription.workshop.slot
                && (this.subscription.workshop.accept_invites != null)
        },
        isLodgeComplete() {
            return this.subscription.lodge.name
                && this.subscription.lodge.type
                && (Object.keys(this.subscription.lodge.days).length > 0)
                && (Object.values(this.subscription.lodge.days).indexOf(true) > -1)
        },
        isContactLunchComplete() {
            return this.subscription.contact_lunch.name
                && (Object.keys(this.subscription.contact_lunch.lunches).length > 0)
                && (Object.values(this.subscription.contact_lunch.lunches).reduce((pv, cv) => pv + cv, 0) > 0);
        }
    },
    components: {
        MaxLengthInput,
        Wysiwyg,
        Dropdown,
        DropdownClick,
        Modal,
        MaxLengthTextarea,
        AppNotifications,
        inputPassword,
        Tabs,
        Tab,
        Accordion,
        OrderSummaryTable,
        FileUploader,
        FileUploaderCropper,
        BadgeForm,
        ExtendedBadgeForm,
        CompanyForm,
        StartupForm,
        Snackbar,
        searchSelect,
        searchSelectTooltip,
        SimpleSearchSelect,
        ToggleFavoriteButton,
        ToggleVerifiedButton,
        ToggleValidatedButton,
        ToggleStatusButton,
        ToggleButton,
        DeleteConfirmButton,
        BringOwnBadgesField,
        RefuseMealsField,
        ContactLunch,
        cvlibMultiSelect,
        AddUpdateDeleteForm,
        LunchDayMeals,
        StandConfigFurnitureForm,
        CvlibPackForm,
        Vstyle,
        vSelect,
        Validations,
        CompanyValidations,
        DayTimeRangeForm,
        OverlappedDayTimeRangeForm,
        MarkdownEditor,
        CompanySubscriptionMultiSelect,
        LogisticMultiCompanySelect,
        AppointmentsManagement,
        GenerateAppointmentForm,
        DayTimeRangeSelector,
        CompanyComment,
        CompanyTimeline,
        TodoListModal
    },
    methods: {
        openWaitingListConfirm(currentCapacity, waitingCount) {
            const capacityInputs = document.querySelectorAll('input[name^="day_time_ranges"][name$="[capacity]"]');
            let newCapacity;
            if (capacityInputs.length > 0) {
                newCapacity = [...capacityInputs].reduce(
                    (acc, input) => acc + (parseInt(input.value, 10) || 0),
                    0,
                );
            } else {
                const daySlots = document.querySelectorAll('input[name^="day_time_ranges"][name$="[day]"]');
                newCapacity = daySlots.length > 0 ? daySlots.length : currentCapacity;
            }

            const freed = Math.max(0, newCapacity - currentCapacity);
            const expected = Math.min(freed, waitingCount);

            const i18n = document.getElementById('waiting-list-confirm-i18n');
            this.waitingListConfirm = {
                total: waitingCount,
                freed,
                expected,
                messages: {
                    noIncrease: i18n ? i18n.dataset.msgNoIncrease : '',
                    partial: i18n ? i18n.dataset.msgPartial : '',
                    all: i18n ? i18n.dataset.msgAll : '',
                },
            };
            this.toggleAModal('modal__confirm_waiting_list');
        },
        pushSnackbar(message, type = 'success', autoDestroy = 3) {
            const id = `snack-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
            this.snackbars.push({ id, message, type, isOpen: true, autoDestroy });
            return id;
        },
        removeSnackbar(id) {
            const index = this.snackbars.findIndex((snack) => snack.id === id);
            if (index !== -1) {
                this.snackbars.splice(index, 1);
            }
        },
        markAsRead(route, id) {
            axios.post(route, {
                    'notification': id
                }
            ).then((response) => {
                console.log(response);
            }).catch(function (error) {
                // error management?
                console.log(error);
            });
        },
        reportFormValidity(ref) {
            return this.$refs[ref].reportValidity();
        },
        toggleAModal(ref) {
            this.$refs[ref].toggleModal()
        },
        toggleSubmitting() {
            this.submitting = true
            this.$refs.registercompanyforeditionform.submit();
        },
        // Bound to the native submit event of forms that upload large files:
        // reveals the submitting overlay, which also covers the page and so
        // prevents a second submit while the upload is in flight.
        startFormSubmitting() {
            this.formSubmitting = true
        },
        toggleStudentSubmitting() {
            this.studentSubmitting = true
            this.$refs.registerstudentforeditionform.submit();
        },
        needsDisplay: function (ref) {
            if (this.optionalDisplay[ref]) {
                return this.optionalDisplay[ref];
            } else {
                return false;
            }
        },
        setOptionalDisplay: function (ref, value) {
            this.optionalDisplay[ref] = value;
        },
        resetSubscriptionForm: function (ref, value) {
            this.optionalDisplay[ref] = value;
            this.withEcoTax = false;
            this.withNGOSupport = false;
            this.subConfirmation = false;
            this.communicationEmailConfirmed = false;
            this.billingEmailConfirmed = false;
        },
        updateOrderItem: function (ref, type, id, active, linked) {
            let refs = ref.split(',');
            for (let i = 0; i < refs.length; i++) {
                this.$refs[refs[i]].updateOrderItem(type, id, active, linked);
            }
        },
        updateOrderItemQuantity: function (ref, type, id, quantity) {
            let refs = ref.split(',');
            for (let i = 0; i < refs.length; i++) {
                this.$refs[refs[i]].updateOrderItemQuantity(type, id, quantity);
            }
        },
        updateOrderItemDiscount: function (ref, type, id, discount) {
            let refs = ref.split(',');
            for (let i = 0; i < refs.length; i++) {
                this.$refs[refs[i]].updateOrderItemDiscount(type, id, discount);
            }
        },
        updateOrderItemPrice: function (ref, type, id, price) {
            let refs = ref.split(',');
            for (let i = 0; i < refs.length; i++) {
                this.$refs[refs[i]].updateOrderItemPrice(type, id, price);
            }
        },
        toggleOrderDay: function (ref, id, active) {
            let refs = ref.split(',');
            for (let i = 0; i < refs.length; i++) {
                this.$refs[refs[i]].toggleOrderDay(id, active);
            }
        },

        standSizeIsAvailable: function (size) {

            if (Object.keys(this.subscription.stand.days).length === 0) return false;

            for (var day in this.subscription.stand.days) {

                if (this.subscription.stand.days[day]) {
                    if (this.subscription.stand.availabilities[day].indexOf(size) < 0) {
                        return false;
                    }
                }
            }
            return true;
        },
        deselectAllCheckedItems: function (ref) {
            if (this.$refs[ref]) {
                var items = this.$refs[ref].getElementsByTagName('input');
                for (let item of items) {
                    if (item.checked) {
                        item.checked = false;
                        item.dispatchEvent(new Event('change'));
                    }
                }

            }
        },
        deselectItemsWithDataId: function (ref, id) {
            if (this.$refs[ref]) {
                var items = this.$refs[ref].getElementsByTagName('input');
                for (let item of items) {
                    if (item.dataset.id == id) {
                        item.setAttribute('value', 0);
                        item.dispatchEvent(new Event('change'));
                    }
                }
                //this.$refs[ref + "-" + dayId].setAttribute('value', 0);
            }

        },
        standHasSelectedDays: function () {
            for (var day in this.subscription.stand.days) {
                if (this.subscription.stand.days[day]) {
                    return true;
                }
            }
            return false;
        },
        addStandDay: function (day) {
            const formattedDate = moment(day.day);
            this.config.stand.formatted_days[day.id] = formattedDate.format('DD.MM.YYYY');
            this.config.stand.size_limits_limit = {
                ...this.config.stand.size_limits_limit,
                [day.id]: {},
            };
            this.config.stand.size_limits_initial_total[day.id] = 0;
        },
        toggleStudyLevels: function (ref, target) {
            if (this.$refs[ref]) {
                var items = this.$refs[ref].getElementsByTagName('input');

                if (target.dataset.selector == "all") {
                    if (target.checked) {
                        for (let item of items) {
                            if (item.checked && item != target) {
                                item.checked = false;
                            }
                        }
                    } else {
                        //If you try to deselect the all, it auto reselect
                        target.checked = true;
                    }

                } else {
                    if (target.checked) {
                        for (let item of items) {
                            if (item.dataset.selector == "all") {
                                item.checked = false;
                            }
                        }
                    } else {
                        var hasStillChecked = false;
                        var allLevels = null;
                        for (let item of items) {
                            if (item.dataset.selector == "all") {
                                allLevels = item;
                            } else {
                                if (item.checked) {
                                    hasStillChecked = true;
                                }
                            }
                        }
                        if (!hasStillChecked) {
                            allLevels.checked = true;
                        }

                    }
                }

            }
        },
        isTimeBetween(slotTime, startTime, endTime) {

            if (slotTime == null) return false;

            var t1 = new Date();
            var parts = slotTime.split(":");
            t1.setHours(parts[0], parts[1], 0, 0);

            var t2 = new Date();
            parts = startTime.split(":");
            t2.setHours(parts[0], parts[1], 0, 0);

            var t3 = new Date();
            parts = endTime.split(":");
            t3.setHours(parts[0], parts[1], 0, 0);

            // returns 1 if greater, -1 if less and 0 if the same
            return (t1.getTime() >= t2.getTime() && t1.getTime() <= t3.getTime());
        },
        timeDiffInMinutes(slotTime, startTime) {

            if (slotTime == null) return 0;

            var t1 = new Date();
            var parts = slotTime.split(":");
            t1.setHours(parts[0], parts[1], 0, 0);

            var t2 = new Date();
            parts = startTime.split(":");
            t2.setHours(parts[0], parts[1], 0, 0);

            return parseInt(Math.abs(t1.getTime() - t2.getTime()) / (60 * 1000));
        },

        setGlobalFavorite(idStudent, isFavorite) {
            Vue.set(this.favorites, idStudent, isFavorite);
        },

        setGlobalVerified(id, value) {
            if (value) {
                this.setGlobalStatus(id, null);
            }
            Vue.set(this.verified, id, value);
        },

        setGlobalValidated(id, value) {
            if (value) {
                this.setGlobalStatus(id, null);
            }
            Vue.set(this.validated, id, value);
        },

        setGlobalStatus(id, status) {
            Vue.set(this.statuses, id, status);
        },

        setGlobalGoodiesReceived(id, value) {
            Vue.set(this.goodiesReceived, id, value);
        },

        toggleStudentSelection(id, name, event) {

            if (event.target.checked) {
                Vue.set(this.cvlib.selectedStudents, id, name);
            } else {
                Vue.delete(this.cvlib.selectedStudents, id);
            }
        },

        toggleItemSelection(id, name, event) {
            if (event.target.checked) {
                Vue.set(this.search.selectedItems, id, name);
            } else {
                Vue.delete(this.search.selectedItems, id);
            }
        },

        clearStudentSelection() {
            Object.keys(this.cvlib.selectedStudents).forEach((key) => {
                Vue.delete(this.cvlib.selectedStudents, key);
            });
        },

        clearItemSelection() {
            Object.keys(this.search.selectedItems).forEach((key) => {
                Vue.delete(this.search.selectedItems, key);
            });
        },

        inviteStudents(students) {
            this.cvlib.studentsToInvite = {};
            students.forEach((student) => {
                Vue.set(this.cvlib.studentsToInvite, student.id, student.name);
            });
            this.toggleAModal('modal__register');
        },

        inviteMultiSelectedStudent() {
            const studentArrayToInvite = [];
            Object.keys(this.cvlib.selectedStudents).forEach((id) => {
                studentArrayToInvite.push({'id': id, 'name': this.cvlib.selectedStudents[id]})
            });
            this.inviteStudents(studentArrayToInvite);
        },

        addToFavoriteMultiSelectedStudent(route) {
            const studentsArrayAddFavorite = [];
            Object.keys(this.cvlib.selectedStudents).forEach((id) => {
                studentsArrayAddFavorite.push(id)
            });
            //this.inviteStudents(studentArrayToInvite);
            axios.post(route, {
                    'students': studentsArrayAddFavorite
                }
            ).then((response) => {
                let favorites = response.data.favorites;
                favorites.forEach((favorite) => {
                    this.setGlobalFavorite(favorite.id, favorite.favorite)
                });
            }).catch(function (error) {
                // error management?
                console.log(error);
            });
        },

        setVerifiedStatusMultiSelectedCompanies(route) {
            Object.keys(this.search.selectedItems).forEach(id => {
                axios.post(route, {
                    item: id
                }).then(response => {
                    const isVerified = response.data.is_on;
                    this.setGlobalVerified(id, isVerified);
                }).catch(error => {
                    console.log(error);
                });
            });
        },

        setVisibilitySettingMultiSelectedForumActivities(route) {
            Object.keys(this.search.selectedItems).forEach(id => {
                axios.post(route, {
                    item: id
                }).then(response => {
                    const isVisible = response.data.is_on;
                    this.setGlobalVerified(id, isVisible);
                }).catch(error => {
                    console.log(error);
                });
            });
        },

        generateBills() {
            for (const companySubscriptionId of Object.keys(this.search.selectedItems)) {
                axios.post('/admin/bills/emit', {
                    'subscription': companySubscriptionId
                }).then(() => this.search.selectedItems[companySubscriptionId] = true);
            }
        },

        setActivitySelected(event) {
            /*this.cvlib.selectedActivity.needsSchedule = event.target.options[event.target.selectedIndex].dataset.needsschedule;
            this.cvlib.selectedActivity.needsDays = event.target.options[event.target.selectedIndex].dataset.needsdays;*/
        },
        checkValidity(ref) {
            if (this.$refs[ref]) {
                return !this.$refs[ref].checkValidity();
            }
            return true;
        },
        setExport() {
            this.$refs.export.value = 1;
            this.$refs.searchform.target = "_blank";
            this.$refs.searchform.submit();
            this.$refs.searchform.target = "_self";
            this.$refs.export.value = 0;
        },
        setOptExport() {
            this.$refs.opt_export.value = 1;
            this.$refs.searchform.target = "_blank";
            this.$refs.searchform.submit();
            this.$refs.searchform.target = "_self";
            this.$refs.opt_export.value = 0;
        },
        setAdminCreatePrestation() {
            if (this.admin.selectCompany != null) {
                window.open(this.admin.selectCompany.route, '_blank');
            }
        },
        goLink(path) {
            window.location.href = path;
        },

        loadDefaultBillEmailIfNeeded(route) {
            if (this.billSendEmail.defaultsLoaded) {
                return;
            }

            axios.get(route)
                .then((response) => {
                    this.billSendEmail.customSubject = response.data.subject;
                    this.billSendEmail.customGreeting = response.data.greeting;
                    this.billSendEmail.customContent = response.data.content;
                    this.billSendEmail.customSalutation = response.data.salutation;
                    this.billSendEmail.customSignature = response.data.signature;
                    this.billSendEmail.defaultsLoaded = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        submitBillSendEmail(route, modalRef) {
            if (this.billSendEmail.isSending) {
                return;
            }

            this.billSendEmail.isSending = true;

            const payload = {
                email_mode: this.billSendEmail.emailMode,
            };

            if (this.billSendEmail.emailMode === 'custom') {
                payload.custom_subject = this.billSendEmail.customSubject;
                payload.custom_greeting = this.billSendEmail.customGreeting;
                payload.custom_content = this.billSendEmail.customContent;
                payload.custom_salutation = this.billSendEmail.customSalutation;
                payload.custom_signature = this.billSendEmail.customSignature;
            }

            axios.post(route, payload)
                .then(() => {
                    this.resetBillSendEmail(modalRef);
                    window.location.reload();
                })
                .catch((error) => {
                    console.log(error);
                    this.billSendEmail.isSending = false;
                });
        },

        resetBillSendEmail(modalRef) {
            this.billSendEmail.emailMode = 'standard';
            this.billSendEmail.customSubject = '';
            this.billSendEmail.customGreeting = '';
            this.billSendEmail.customContent = '';
            this.billSendEmail.customSalutation = '';
            this.billSendEmail.customSignature = '';
            this.billSendEmail.defaultsLoaded = false;
            this.billSendEmail.isSending = false;
            this.toggleAModal(modalRef);
        },

        formatPrice(amount) {
            if (!amount) return '';
            return 'CHF ' + parseFloat(amount).toLocaleString('fr-CH', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        },
        /*   // helper's method translated in js, using accounting-js library
           /!**
            * @return {string}
            *!/
           CHF(amount){
                return formatMoney(amount, {symbol: 'CHF', precision: 2, thousand : "'" , decimal: ","}).concat('.-');
           },
           priceCHF(amount){
               return CHF(amount).replace('CHF', '');
           },
     */
    },
});

global.vm = vm;


/*****************************************
 * jQuery toggle mobile nav
 ******************************************/


$('.js-toggle-profilenav').on('click', function () {
    $('.mainnav').removeClass('isOpen');
    $('.profilenav .menu').toggleClass('isOpen');
})

$('.js-toggle-mainnav').on('click', function () {
    $('.profilenav .menu').removeClass('isOpen');
    $('.mainnav').toggleClass('isOpen');
})

var clipboard = new ClipboardJS('.clipbutton');

tippy(document.querySelectorAll('.clipbutton'), {
    trigger: 'click',
});

tippy('.studysections_description', {
    content: '',
    trigger: 'mouseenter',
});

tippy('.stand-type__tooltip', {
    trigger: 'mouseenter',
    allowHTML: true,
});

// Waiting list drag & drop reorder
(() => {
    const el = document.getElementById('waiting-list-sortable');
    if (!el) return;

    const renumber = (items) => {
        items.forEach((item, index) => {
            item.querySelector('.timetablePreview__position').textContent = index + 1;
        });
    };

    let previousOrder = [...el.children];

    Sortable.create(el, {
        handle: '.timetablePreview__handle',
        animation: 150,
        ghostClass: 'timetablePreview--ghost',
        onStart() {
            previousOrder = [...el.children];
        },
        onEnd() {
            const items = [...el.querySelectorAll('.timetablePreview--sortable')];
            renumber(items);
            const order = items.map((item) => parseInt(item.dataset.id));

            el.classList.add('waiting-list-sortable--saving');

            const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            fetch(el.dataset.reorderUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': token,
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ order }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Reorder failed: ' + response.status);
                    }
                    vm.pushSnackbar(el.dataset.reorderSuccess, 'success');
                })
                .catch(() => {
                    previousOrder.forEach((item) => el.appendChild(item));
                    renumber([...el.querySelectorAll('.timetablePreview--sortable')]);
                    vm.pushSnackbar(el.dataset.reorderError, 'error');
                })
                .finally(() => {
                    el.classList.remove('waiting-list-sortable--saving');
                });
        },
    });
})();

